"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCookie = parseCookie;
exports.getFilteredUrlPartsWithReferrer = exports.getFilteredUrlParts = exports.removeQueryStringFromHash = exports.parseAndObfuscateQueryString = exports.obfuscateQstringParams = void 0;

var _jsCookie = require("js-cookie");

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DENY_LIST_QUERY = ['password', 'lastname', 'firstname', 'email', 'company', 'username'];
var DENY_LIST_HOSTS = ['restore-backup.'];

function parseCookie(cookieKey) {
  return {
    [cookieKey]: (0, _jsCookie.get)(cookieKey)
  };
}

var obfuscateQstringParams = qstring => {
  var params = _queryString.default.parse(qstring);

  var paramsArray = Object.entries(params).map((_ref) => {
    var [key, value] = _ref;

    if (value) {
      var safeValue = value;

      if (DENY_LIST_QUERY.includes(key.toLocaleLowerCase()) && value) {
        safeValue = '*'.repeat(value.length);
      }

      return "".concat(key, "=").concat(safeValue);
    }

    return key;
  });
  return paramsArray.length ? "?".concat(paramsArray.join('&')) : '';
};

exports.obfuscateQstringParams = obfuscateQstringParams;

var parseAndObfuscateQueryString = pathAndQueryString => {
  var hashParts = pathAndQueryString.split('?');
  var hashSearch = hashParts[1];

  if (hashSearch) {
    var maskedHashSearch = obfuscateQstringParams(hashSearch);
    return "".concat(hashParts[0]).concat(maskedHashSearch);
  }

  return pathAndQueryString;
};

exports.parseAndObfuscateQueryString = parseAndObfuscateQueryString;

var removeQueryStringFromHash = hashStr => {
  return (hashStr === null || hashStr === void 0 ? void 0 : hashStr.length) ? hashStr.split('?')[0] : '';
};

exports.removeQueryStringFromHash = removeQueryStringFromHash;

var getFilteredUrlParts = props => {
  var filteredProps = {
    url: '',
    path: '',
    search: '',
    hash: ''
  };

  try {
    var urlObj = new URL(props.url || window.location.href); // Don't send deny-list urls:

    if (DENY_LIST_HOSTS.some(urlPart => urlObj.host.includes(urlPart))) {
      return filteredProps;
    } // Prefer user input to browser native values:


    var searchInput = props.search || urlObj.search;
    var pathInput = props.path || urlObj.pathname; // We (strangely) also sometimes put a query string on our hash, so let's deal with that, too:

    urlObj.hash = parseAndObfuscateQueryString(urlObj.hash); // Mask sensitive params on the query string:

    urlObj.search = obfuscateQstringParams(searchInput);
    filteredProps.search = urlObj.search; // We're currently sometimes concatting the query string to the path upstream of here in the sanitizeLocation function. Thus, we'll need to make sure we spunge the path of PII, too.

    filteredProps.path = parseAndObfuscateQueryString(pathInput); // Re-compose the full URL with the updated query string and hash:

    filteredProps.url = urlObj.toString();
    filteredProps.hash = removeQueryStringFromHash(urlObj.hash);
  } catch (e) {
    console.error("Failed to parse url: ".concat(filteredProps.url, ". ").concat(e.message));
  }

  return filteredProps;
};

exports.getFilteredUrlParts = getFilteredUrlParts;

var getFilteredUrlPartsWithReferrer = props => {
  var filteredUrlParts = getFilteredUrlParts(props);
  return _objectSpread(_objectSpread({}, filteredUrlParts), {}, {
    referrer: getFilteredUrlParts({
      url: props.referrer || document.referrer
    }).url
  });
};

exports.getFilteredUrlPartsWithReferrer = getFilteredUrlPartsWithReferrer;
//# sourceMappingURL=urlHelpers.js.map